import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { AppDialogComponent } from 'src/app/components/app-dialog/app-dialog.component';
import { Device, DeviceAccessSource } from 'src/app/models/data/device';
import { SystemCapabilityEnum } from 'src/app/models/data/systemCapability';
import { ApiService } from 'src/app/services/api.services';
import { AuthService, UserSession } from 'src/app/services/auth.service';
import { SystemCapabilityService } from 'src/app/services/system-capabilities/system-capability.service';
import { NotAuthorizedNoticeComponent } from '../../../components/not-authorized-notice/not-authorized-notice.component';
import { AppTabNavigationHeaderComponent } from '../../../components/navigation-header/app-navigation-header.component';
import { MatTabGroup, MatTab, MatTabContent } from '@angular/material/tabs';
import { QueryStringTabGroupDirective } from '../../../directives/query-string-tab-group.directive';
import { UserAccessTabComponent } from '../../shared/user-access-tab/user-access-tab.component';
import { BreadcrumbLabelDirective } from '../../../directives/breadcrumb-label.directive';
import { CompanyAccessTabComponent } from '../../shared/company-access/company-access.component';

@Component({
	selector: 'app-access-main',
	templateUrl: './access-main.component.html',
	styleUrls: ['./access-main.component.scss', '../../common/main.scss'],
	imports: [
		NotAuthorizedNoticeComponent,
		AppTabNavigationHeaderComponent,
		MatTabGroup,
		QueryStringTabGroupDirective,
		MatTab,
		MatTabContent,
		UserAccessTabComponent,
		BreadcrumbLabelDirective,
		CompanyAccessTabComponent,
	],
})
export class AccessMainTabComponent implements OnDestroy {
	public hasDeviceManagement = false;
	public devices: {
		device: Device;
		groupNames?: string[];
		source?: DeviceAccessSource;
	}[] = [];

	companyId?: string;

	userSession?: UserSession;
	userSubscription?: Subscription;

	breadcrumbLabel = $localize`:@@accessMain-breadcrumbLabel:Device Access`;

	controlsBreadcrumbLabel = this.breadcrumbLabel;
	userAccessBreadcrumbLabel = this.breadcrumbLabel;
	companyAccessBreadcrumbLabel = this.breadcrumbLabel;

	constructor(
		private readonly scService: SystemCapabilityService,
		private readonly apiService: ApiService,
		private readonly authService: AuthService,
		private dialog: MatDialog
	) {
		this.userSubscription = this.authService
			.userSession()
			.subscribe(async (session) => {
				this.userSession = session;
				this.companyId =
					this.userSession?.assignedRole?.entityRelationship?.parentEntityId;
				this.hasDeviceManagement = this.scService.has(
					SystemCapabilityEnum.deviceManagement
				);
				await this.populateDeviceList();
			});
	}

	get hasOwnedDevices(): boolean {
		const ownedDevices = this.devices.filter(
			(device) =>
				device.device.activeDeviceAssignment?.companyId === this.companyId
		);
		return ownedDevices.length > 0;
	}

	async populateDeviceList(): Promise<void> {
		// Must have CompanyId to populate the list
		if (!this.companyId) {
			console.error('No company id...');
			this.dialog.open(AppDialogComponent, {
				data: {
					title: 'Error',
					message: 'Company ID is missing, unable to load device list.',
				},
			});
			return;
		}

		this.devices = await this.apiService.getAllDevices();
	}

	ngOnDestroy(): void {
		this.userSubscription?.unsubscribe();
		this.userSubscription = undefined;
	}
}
